/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guest_Book_ErrorInputs */

const en_guest_book_error = /** @type {(inputs: Guest_Book_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The booking could not be sent. Please try again.`)
};

const pl_guest_book_error = /** @type {(inputs: Guest_Book_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nie udało się wysłać rezerwacji. Spróbuj jeszcze raz.`)
};

/**
* | output |
* | --- |
* | "The booking could not be sent. Please try again." |
*
* @param {Guest_Book_ErrorInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const guest_book_error = /** @type {((inputs?: Guest_Book_ErrorInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guest_Book_ErrorInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_guest_book_error(inputs)
	return en_guest_book_error(inputs)
});